export default function disallowSpecialCharacters(event) {
    const key = event.which || event.keyCode || 0
    return (
        (key >= 48 && key <= 57) || // Numbers
        (key >= 97 && key <= 122) || // Lower-case letters
        key == 45 // Hyphen
    )
}
